import './main.css';
import { createApp } from 'vue';
import './style/header.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './iconfont/iconfont.css';

// 引入element
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

(async function () {
    await createApp(App).use(store).use(router).use(ElementPlus).mount('#app');
})();
